import React from "react";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/cms/products");
  };

  return (
    <div style={{ padding: "50px 0" }}>
      <Result
        icon={<LockOutlined style={{ color: "#faad14" }} />}
        title={t("access_denied")}
        subTitle={t("access_denied_message")}
        extra={
          <div>
            <Button type="primary" onClick={handleGoHome} style={{ marginRight: 8 }}>
              {t("go_to_home")}
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default AccessDenied;
